import React from 'react';
import cn from 'classnames';
import { Icon } from '@iconify/react';
import iconCheck from '@iconify-icons/mdi/check';
import { TRANSLATIONS } from '../../../../translations';

const PartnerSignupSuccess = () => {
  return (
    <div className="modal-partner-signup success">
      <Icon icon={iconCheck} className={cn('icon')} />
        <p>{TRANSLATIONS.PARTNER_REGISTRATION_COMPLETE}</p>
    </div>
  )
}

export default PartnerSignupSuccess;
